/**
 * Shared synchronous consent reader.
 *
 * Used by modules that need to gate side effects (Sentry, error logging,
 * web vitals) without depending on React context. The source of truth is
 * the `consent_state` key in localStorage written by ConsentPopup.
 *
 * Default is DENY — anything that reaches this helper before the user has
 * answered the consent prompt is treated as non-consented.
 */

const CONSENT_KEY = "consent_state";

export function consentAllowsAnalytics(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed?.accepted_analytics === true;
  } catch {
    return false;
  }
}
